// Сколько костей урона бросает отряд селестиалов в ближнем бою (у остальных
// фракций — 2). В формулу урона идут лучшие MELEE_COUNTED_DAMAGE_DICE_COUNT из
// них (см. getMeleeCountedDiceRolls)
export const CELECTIALS_MELEE_DAMAGE_DICE_COUNT = 4;
